export enum MetodoPagamentoVendaEnum {
  PIX = 1,
  BOLETO,
  CARTAO_CREDITO,
  PAY_PAL,
  APPLE_PAY,
  GOOGLE_PAY,
  AMAZON_PAY,
}

export const MetodoPagamentoVendaDescricao: {
  [key in MetodoPagamentoVendaEnum]: string;
} = {
  [MetodoPagamentoVendaEnum.PIX]: 'Pix',
  [MetodoPagamentoVendaEnum.BOLETO]: 'Boleto',
  [MetodoPagamentoVendaEnum.CARTAO_CREDITO]: 'Cartão de Crédito',
  [MetodoPagamentoVendaEnum.PAY_PAL]: 'PayPal',
  [MetodoPagamentoVendaEnum.APPLE_PAY]: 'Apple Pay',
  [MetodoPagamentoVendaEnum.GOOGLE_PAY]: 'Google Pay',
  [MetodoPagamentoVendaEnum.AMAZON_PAY]: 'Amazon Pay',
};
